import Img1 from "../assets/images/landing/pizzaslice.webp";
import Img2 from "../assets/images/landing/award.webp";
import Img3 from "../assets/images/landing/customer.webp";
import Img4 from "../assets/images/landing/chef.webp";

const statsPreview = [
    {
        id: 1,
        img: Img1,
        stats: '5',
        name: 'Pizzafilialen',
    },
    {
        id: 2,
        img: Img2,
        stats: '20',
        name: 'Auszeichnungen',
    },
    {
        id: 3,
        img: Img3,
        stats: '10.485+',
        name: 'Zufriedene Kunden',
    },
    {
        id: 4,
        img: Img4,
        stats: '40+',
        name: 'Mitarbeitende',
    },
]

export default statsPreview;